export default (value: string): string => (value || '').replace(/(<([^>]+)>)/gi, '');
